import Vue from 'vue';
import VueRouter from "vue-router";
import App from "./App.vue";
import axios from 'axios'
import VueAxios from 'vue-axios'
// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";
// router setup
import routes from "./routes/routes";
import money from 'v-money'

// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(VueAxios, axios);
Vue.use(money, {precision: 4})

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  mode: 'history',
  base: '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
});

// Registrar el Service Worker
if ('serviceWorker' in navigator) {
  if (!isAppleDevice()) {
    import('./firebase.js')
    .then((module) => {
      const messaging = module.messaging;
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
          .then((registration) => {
            console.log('Service Worker registrado1:', registration);
            messaging.useServiceWorker(registration);
          })
          .catch((error) => {
            console.error('Error al registrar el Service Worker:', error);
          });
      });
    })
    .catch((error) => {
      console.error(error);
    });
  } else{
    import('./firebase.js')
    .then((module) => {
      if (module.messaging.isSupported()){
        console.log('soportado')
        const messaging = module.messaging();
      }
    })
    .catch((error) => {
      console.error('Error al registrar el Service Worker:', error);
    });
  }
}
// Verificar si el dispositivo es de Apple (iOS)
function isAppleDevice() {
  const userAgent = navigator.userAgentData;
  return /iPhone|iPad|iPod/i.test(userAgent);
}